document.addEventListener('DOMContentLoaded', function () {
  const wrapper = document.querySelector('[data-account-forms]')

  if (!wrapper) return

  const panels = wrapper.querySelectorAll('[data-account-panel]')

  function showPanel(name) {
    let matched = false

    panels.forEach(panel => {
      if (panel.dataset.accountPanel === name) {
        panel.classList.remove('hidden')
        matched = true
      } else {
        panel.classList.add('hidden')
      }
    })

    return matched
  }

  wrapper.querySelectorAll('[data-account-switch]').forEach(link => {
    link.addEventListener('click', function (e) {
      e.preventDefault()
      const target = this.dataset.accountSwitch
      showPanel(target)
      history.replaceState(null, '', '#' + target)
    })
  })

  function showPanelFromHash() {
    const hash = window.location.hash.replace('#', '')
    if (hash) {
      showPanel(hash)
    }
  }

  showPanelFromHash()
  window.addEventListener('hashchange', showPanelFromHash)
})
